module.exports = __webpack_public_path__ + "img/negative-result.1b5045b7.svg";